import React, { useEffect, useState, useRef } from 'react';
import { Offcanvas, Button, Form, Modal, OverlayTrigger, Tooltip, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faInfoCircle, faClock, faUserPlus, faTruck, faWarehouse, faClipboardList, faCircle, faEllipsisH, faCalendarAlt, faFileAlt, faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import SubtleBadge from 'components/common/subtleBadge';
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import DatePicker from 'react-datepicker';
import { setHours, setMinutes } from 'date-fns';
import moment from 'moment';
import TimeInput from '../proposals/timeInput';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import FalconCloseButton from 'components/common/falconCloseButton';
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { fetchTemplatesByCustomer, sendEmailToCleaner, validateCustomerEmailConfig, dispatchBatchNotification, notifyLeaveRequested, fetchEmployeeScheduledSlots, combineDateAndTimeOfDay, findEmployeeTimeConflict, checkEmployeeAvailability, clearEmployeeAvailabilityCache, SchedulingIssuesModal, fetchFilteredUsers, fetchRecommendedEmployees, sortEmployeesAscending, partitionRecommendedEmployees } from '../../assets/js/common';

const UnavailabilitySidepanel = ({
    open,
    onClose,
    type = 'vacation',
    // status = 'approved',
    loading = false,
    data = null,
    unavailabilityId = null,
    onDeleted = () => { },
    mode = 'view',
    onUpdated,
    onDecision,
    decisionLoading,
    t = (key) => key,
    conflictMap = {},
}) => {
    const [decisionNote, setDecisionNote] = useState('');
    const [registerType, setRegisterType] = useState('vacation');
    const [isEditMode, setIsEditMode] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const normalizedType = data?.Type?.toLowerCase();
    const normalizedStatus = data?.Status?.toLowerCase();
    const isSick = normalizedType === 'sickness';
    const isApproved = normalizedStatus === 'approved';
    const isRejected = data?.Status === "rejected";
    const isRegisterMode = mode === 'register';
    const isRegisterSick = registerType === 'sickness';
    const isEmployeeView = sessionStorage.getItem('isEmployeeView') === 'true' || localStorage.getItem('UserRole') === 'Employee';
    const communicationUserId = localStorage.getItem('UserId');
    const culture = localStorage.getItem('culture') || 'nl';
    const [editLeaveType, setEditLeaveType] = useState(isSick ? 'sickness' : 'vacation');
    const [editFrom, setEditFrom] = useState(null);
    const [editTo, setEditTo] = useState(null);
    const [editNotes, setEditNotes] = useState("");
    const isPastLeave = moment(data?.EndDate).isBefore(moment(), 'day');
    const canEmployeeEdit = !(isEmployeeView && isPastLeave);
    const [historyRecords, setHistoryRecords] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(false);
    const [existingUnavailabilities, setExistingUnavailabilities] = useState([]);
    const [affectedTasks, setAffectedTasks] = useState([]);
    const [tasksLoading, setTasksLoading] = useState(false);
    const [selectedTaskIds, setSelectedTaskIds] = useState([]);
    const [assignToEmployee, setAssignToEmployee] = useState(null);
    const [shouldReassignAllAffectedTasks, setShouldReassignAllAffectedTasks] = useState(false);
    const [activeReassignIdx, setActiveReassignIdx] = useState(null);
    const [showAllTasks, setShowAllTasks] = useState(false);
    const [showAllHistory, setShowAllHistory] = useState(false);
    const [preApplySelection, setPreApplySelection] = useState([]);
    const navigate = useNavigate();
    const status = data?.Status?.toLowerCase();
    const [unavailabilitiesLoading, setUnavailabilitiesLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [employeesLoading, setEmployeesLoading] = useState(false);
    const [showCombinedIssuesModal, setShowCombinedIssuesModal] = useState(false);
    const [pendingCombinedIssues, setPendingCombinedIssues] = useState(null);
    const [pendingAssignEmployee, setPendingAssignEmployee] = useState(null);
    const [recommendedEmployeeGroups, setRecommendedEmployeeGroups] = useState({});
    const recommendationRequestRef = useRef(0);
    const recommendationDebounceRef = useRef(null);

    const getSelectedTaskLocationIds = () => {
        const selectedTasks = selectedTaskIds
            .map(i => affectedTasks[i])
            .filter(Boolean);

        const locationIds = selectedTasks
            .map(task => task.Location)
            .filter(id => id !== null && id !== undefined);

        return [...new Set(locationIds)];
    };

    const getFilteredEmployees = () => {
        const selectedTaskLocationIds = getSelectedTaskLocationIds();

        if (!selectedTaskLocationIds.length) {
            return employees;
        }

        const result = employees.filter(emp => {
            const empLocationArray = (Array.isArray(emp.LocationIds) ? emp.LocationIds : []).map(String);
            const normalizedTaskLocations = selectedTaskLocationIds.map(String);

            return normalizedTaskLocations.every(locId => empLocationArray.includes(locId));
        });
        return result;
    };

    const getFilteredEmployeesForTask = (task) => {
        const taskLocation = task?.Location;
        if (taskLocation === null || taskLocation === undefined) {
            return employees;
        }

        const normalizedTaskLocation = String(taskLocation);
        return employees.filter(emp => {
            const employeeLocations = (Array.isArray(emp.LocationIds) ? emp.LocationIds : []).map(String);
            return employeeLocations.includes(normalizedTaskLocation);
        });
    };

    const loadRecommendationsForTask = async (taskIndex, task, taskIds = selectedTaskIds) => {
        const requestId = ++recommendationRequestRef.current;
        const outgoingEmployeeId = data?.UserId;
        const eligibleEmployees = selectedTaskIds.length > 1
            ? getFilteredEmployees()
            : getFilteredEmployeesForTask(task);
        const fullEmployeeList = sortEmployeesAscending(eligibleEmployees);

        if (!outgoingEmployeeId || !fullEmployeeList.length) {
            if (requestId === recommendationRequestRef.current) setRecommendedEmployeeGroups(prev => ({
                ...prev,
                [taskIndex]: { recommended: [], others: fullEmployeeList },
            }));
            return;
        }

        try {
            const recommendations = await fetchRecommendedEmployees(
                data?.CustomerId || localStorage.getItem('customerId'),
                [outgoingEmployeeId]
            );
            if (!recommendations) {
                if (requestId === recommendationRequestRef.current) setRecommendedEmployeeGroups(prev => ({
                    ...prev,
                    [taskIndex]: { recommended: [], others: fullEmployeeList },
                }));
                return;
            }

            const scopedRecommendations = recommendations.filter(recommendation =>
                fullEmployeeList.some(employee => String(employee.UserId) === String(recommendation.UserId))
            );
            const availabilityCheck = async employee => {
                try {
                    const { issues } = await checkReassignmentConflict(employee, taskIds);
                    return issues?.length ? { type: 'taskConflict' } : null;
                } catch (error) {
                    console.error('Error checking recommendation availability:', error);
                    return { type: 'taskConflict' };
                }
            };
            const groups = await partitionRecommendedEmployees(fullEmployeeList, scopedRecommendations, availabilityCheck);
            if (requestId === recommendationRequestRef.current) setRecommendedEmployeeGroups(prev => ({
                ...prev,
                [taskIndex]: groups,
            }));
        } catch (error) {
            console.error('Error fetching employee recommendations:', error);
            if (requestId === recommendationRequestRef.current) setRecommendedEmployeeGroups(prev => ({
                ...prev,
                [taskIndex]: { recommended: [], others: fullEmployeeList },
            }));
        }
    };

    const scheduleRecommendationsForTask = (taskIndex, task, taskIds) => {
        clearTimeout(recommendationDebounceRef.current);
        recommendationDebounceRef.current = setTimeout(() => {
            void loadRecommendationsForTask(taskIndex, task, taskIds);
        }, 275);
    };

    const isPending = status === "pending";
    const groupRequests =
        existingUnavailabilities?.filter(
            r => r.RequestGroupId === data?.RequestGroupId
        ) || [];

    const sortedRequests = [...groupRequests].sort(
        (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
    );

    const latestRequest = sortedRequests[0];

    const isLatestRequest =
        latestRequest?.UnavailabilityId === data?.UnavailabilityId;

    const showTasks = isLatestRequest && !isRejected && !isEmployeeView;
    const showTaskCheckboxes = showTasks && status !== "pending";

    const isCalendarMode = mode === "calendar";

    const showDecisionButtons =
        isLatestRequest && (status === "pending" || status === "rejected");

    const disableEdit = !isLatestRequest;

    const showAdminNotes =
        isLatestRequest && (status === "pending" || status === "rejected");

    const disableSickEditForEmployeeView = isEmployeeView && isSick;

    const registerSchema = yup.object({
        dateFrom: yup
            .date()
            .required(t('dateFromRequired'))
            .typeError(t('invalidDate')),
        dateTo: yup
            .date()
            .required(t('dateToRequired'))
            .typeError(t('invalidDate'))
            .test(
                'dateTo-after-dateFrom',
                t('dateToAfterDateFrom'),
                function (dateTo) {
                    const { dateFrom } = this.parent;
                    if (dateTo && dateFrom) {
                        return moment(dateTo).isAfter(moment(dateFrom));
                    }
                    return true;
                }
            )
            .test(
                "no-overlap",
                t("unavailabilityOverlapError"),
                function (dateTo) {
                    const { dateFrom } = this.parent;

                    if (!dateFrom || !dateTo) return true;

                    const newStart = moment(dateFrom);
                    const newEnd = moment(dateTo);

                    const hasOverlap = existingUnavailabilities
                        .filter(record => record.Status?.toLowerCase() !== 'rejected')
                        .some((record) => {
                            const recStart = moment(record.StartDate);
                            const recEnd = moment(record.EndDate);

                            return newStart.isBefore(recEnd) && newEnd.isAfter(recStart);
                        });

                    return !hasOverlap;
                }
            ),
        startTime: yup
            .date()
            .nullable()
            .typeError(t('invalidStartTime')),
        endTime: yup
            .date()
            .nullable()
            .typeError(t('invalidEndTime'))
            .test(
                'endTime-after-startTime',
                t('endTimeAfterStartTime'),
                function (endTime) {
                    const { startTime } = this.parent;
                    if (endTime && startTime) {
                        const normalize = (d) => moment(d).set({ year: 2000, month: 0, date: 1 });
                        return normalize(endTime).isSameOrAfter(normalize(startTime));
                    }
                    return true;
                }
            ),
        note: yup.string().max(200)
    });

    const {
        control,
        handleSubmit,
        watch,
        reset,
        trigger,
        formState: { errors },
        setValue, clearErrors
    } = useForm({
        mode: 'onChange',
        resolver: yupResolver(registerSchema),
        defaultValues: {
            dateFrom: null,
            dateTo: null,
            startTime: null,
            endTime: null,
            note: ''
        }
    });

    const editSchema = yup.object({
        editFrom: yup
            .date()
            .required(t('dateFromRequired'))
            .typeError(t('invalidDate')),

        editTo: yup
            .date()
            .required(t('dateToRequired'))
            .typeError(t('invalidDate'))
            .test(
                'editTo-after-editFrom',
                t('dateToAfterDateFrom'),
                function (editTo) {
                    const { editFrom } = this.parent;
                    if (editTo && editFrom) {
                        return moment(editTo).isAfter(moment(editFrom));
                    }
                    return true;
                }
            )
            .test(
                "no-overlap",
                t("unavailabilityOverlapError"),
                function (editTo) {

                    const { editFrom } = this.parent;

                    if (!editFrom || !editTo) return true;

                    const newStart = moment(editFrom);
                    const newEnd = moment(editTo);

                    const hasOverlap = existingUnavailabilities
                        .filter(record => record.Status?.toLowerCase() !== 'rejected')
                        .some((record) => {

                            //ignore the record being edited
                            if (record.UnavailabilityId === data?.UnavailabilityId) {
                                return false;
                            }

                            const recStart = moment(record.StartDate);
                            const recEnd = moment(record.EndDate);

                            return newStart.isBefore(recEnd) && newEnd.isAfter(recStart);
                        });

                    return !hasOverlap;
                }
            ),

        editNotes: yup.string().max(200)
    });

    const {
        control: editControl,
        handleSubmit: handleEditSubmit,
        watch: editWatch,
        trigger: triggerEdit,
        formState: { errors: editErrors },
        reset: resetEditForm,
        setValue: setEditValue
    } = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
        resolver: yupResolver(editSchema),
        defaultValues: {
            editFrom: null,
            editTo: null,
            editNotes: ""
        }
    });

    const watchedEditFrom = editWatch("editFrom");
    const today = new Date();
    const normalizedToday = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate()
    );

    const dateFromValue = watch("dateFrom");

    useEffect(() => {
        if (!open) {
            setIsEditMode(false);
            setRegisterType('vacation');
            setShowDeleteModal(false);
            setShowAllTasks(false);
            setShowAllHistory(false);
            reset();

        }
    }, [open]);

    useEffect(() => {
        if (!open) {
            setSelectedTaskIds([]);
            setAssignToEmployee(null);
            setRecommendedEmployeeGroups({});
            setShouldReassignAllAffectedTasks(false);
            setActiveReassignIdx(null);
            setShowCombinedIssuesModal(false);
            setPendingCombinedIssues(null);
            setPendingAssignEmployee(null);
            return;
        }
        if (assignToEmployee) {
            const stillValid = getFilteredEmployees().some(e => e.UserId === assignToEmployee.UserId);
            if (!stillValid) {
                setAssignToEmployee(null);
            }
        }
        const fetchEmployees = async () => {
            try {
                setEmployeesLoading(true);
                const customerId = localStorage.getItem('customerId');

                const [usersRes, rolesRes] = await Promise.all([
                    axios.get(
                        `${process.env.REACT_APP_API_URL}/userRoute/users/allLocationsWithIds`,
                        {
                            params: { customerId },
                            headers: { Authorization: process.env.REACT_APP_BasicAuthSecret }
                        }
                    ),
                    axios.get(
                        `${process.env.REACT_APP_API_URL}/roleRoute/roles`,
                        { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
                    ),
                ]);

                const activeUsers = (usersRes.data || []).filter(u =>
                    !u.IsDelete && Number(u.Status) === 0
                );

                const nonClientUsers = fetchFilteredUsers(activeUsers, rolesRes.data || []);

                const sortedEmployees = nonClientUsers
                    .sort((a, b) => (a.Name || '').localeCompare(b.Name || ''));

                setEmployees(sortedEmployees);
            } catch (e) {
                console.error('Error fetching employees', e);
            } finally {
                setEmployeesLoading(false);
            }
        };
        fetchEmployees();
    }, [open]);

    const fetchHistory = async () => {
        if (!data?.UnavailabilityId) return;
        try {
            setHistoryLoading(true);
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/userUnavailabilityHistoryRoute/getHistoryByGroup/${data.RequestGroupId}/${data.UnavailabilityId}`,
                { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
            );
            setHistoryRecords(res.data || []);
        } catch (error) {
            console.error("Error fetching history:", error);
        } finally {
            setHistoryLoading(false);
        }
    };

    useEffect(() => {
        if (!open || !data?.UnavailabilityId) return;
        fetchHistory();
    }, [open, data]);

    const fetchAffectedTasks = async () => {
        if (!data?.UserId) return;
        try {
            setTasksLoading(true);
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/orderRoute/affectedTasks`,
                {
                    params: {
                        userId: data.UserId,
                        startDate: moment(data.StartDate).format('YYYY-MM-DD'),
                        endDate: moment(data.EndDate).format('YYYY-MM-DD'),
                        startTime: data.StartTime,
                        endTime: data.EndTime,
                        customerId: data.CustomerId
                    },
                    headers: { Authorization: process.env.REACT_APP_BasicAuthSecret }
                }
            );
            setAffectedTasks(res.data || []);
        } catch (error) {
            console.error("Error fetching affected tasks:", error);
        } finally {
            setTasksLoading(false);
        }
    };

    useEffect(() => {
        if (!open || !data?.UserId) return;
        fetchAffectedTasks();
    }, [open, data]);

    useEffect(() => {
        if (!open || !employees.length || !affectedTasks.length || activeReassignIdx === null) return;
        scheduleRecommendationsForTask(
            activeReassignIdx,
            affectedTasks[activeReassignIdx],
            selectedTaskIds
        );
    }, [open, employees, affectedTasks, activeReassignIdx, selectedTaskIds]);

    useEffect(() => {
        if (!open) return;

        const targetUserId = data?.UserId || localStorage.getItem('UserId');
        if (!targetUserId) return;
        const fetchUnavailabilities = async () => {
            try {
                setUnavailabilitiesLoading(true);

                const res = await axios.get(
                    `${process.env.REACT_APP_API_URL}/userUnavailabilityRoute/unavailabilityByUSer/${targetUserId}`,
                    {
                        headers: {
                            Authorization: process.env.REACT_APP_BasicAuthSecret
                        }
                    }
                );

                setExistingUnavailabilities(res.data || []);

            } catch (error) {
                console.error("Error loading unavailabilities", error);
            } finally {
                setUnavailabilitiesLoading(false);
            }
        };

        fetchUnavailabilities();

    }, [open, data?.UserId]);

    const badgeColor =
        normalizedStatus === "approved"
            ? "success"
            : normalizedStatus === "rejected"
                ? "danger"
                : "warning";

    const formatDateRange = (start, end) => {
        if (!start || !end) return "--";

        const startMoment = moment(start);
        const endMoment = moment(end);

        const startMonthKey = startMoment.format("MMMM").toLowerCase();
        const endMonthKey = endMoment.format("MMMM").toLowerCase();

        const startMonth = t(`shortMonths.${startMonthKey}`);
        const endMonth = t(`shortMonths.${endMonthKey}`);

        const startFormatted = `${startMoment.format("DD")} ${startMonth} ${startMoment.format("YYYY")}`;
        const endFormatted = `${endMoment.format("DD")} ${endMonth} ${endMoment.format("YYYY")}`;

        return `${startFormatted} – ${endFormatted}`;
    };

    // Convert UTC date + time → local HH:mm
    const formatLocalTime = (dateStr, timeStr) => {
        if (!dateStr || !timeStr) return "--";

        const time = moment.utc(timeStr).format("HH:mm:ss");

        const combined = moment.utc(
            `${moment(dateStr).format("YYYY-MM-DD")}T${time}`
        );

        return combined.local().format("HH:mm");
    };

    // Time Range
    const formatTimeRange = () => {
        if (!data) return "--";

        const start = formatLocalTime(data.StartDate, data.StartTime);
        const end = formatLocalTime(data.EndDate, data.EndTime);

        return `${start} → ${end}`;
    };

    const formatTaskLocalTime = (dateStr, timeStr) => {
        if (!dateStr || !timeStr) return "--";
        const combined = moment.utc(`${dateStr}T${timeStr}`);
        return combined.local().format("HH:mm");
    };

    const calculateDuration = () => {
        if (!data?.StartDate || !data?.EndDate) return "--";

        if (data?.StartTime && data?.EndTime) {
            const startMoment = moment.utc(data.StartTime);
            const endMoment = moment.utc(data.EndTime);
            const diffHours = endMoment.diff(startMoment, "minutes") / 60;

            if (diffHours > 0 && diffHours < 8) {
                const hrs = Math.floor(diffHours);
                const mins = Math.round((diffHours - hrs) * 60);
                return mins > 0
                    ? `${hrs}${t("hours")} ${mins}${t("minutes")}`
                    : `${hrs}${t("hours")}`;
            }
        }

        const start = moment(data.StartDate).startOf("day");
        const end = moment(data.EndDate).startOf("day");
        const diff = end.diff(start, "days") + 1;
        return t("day", { count: diff });
    };

    useEffect(() => {
        if (!open || !data) return;

        setEditLeaveType(data.Type?.toLowerCase());

        const startDate = moment(data.StartDate).startOf("day");
        const endDate = moment(data.EndDate).startOf("day");

        const convertTimeToLocal = (timeStr) => {
            if (!timeStr) return { hours: 0, minutes: 0 };

            const utcTime = moment.utc(timeStr);
            const localTime = utcTime.local();

            return {
                hours: localTime.hours(),
                minutes: localTime.minutes()
            };
        };

        const startTime = convertTimeToLocal(data.StartTime);
        const endTime = convertTimeToLocal(data.EndTime);

        const finalStart = startDate.clone()
            .hour(startTime.hours)
            .minute(startTime.minutes);

        const finalEnd = endDate.clone()
            .hour(endTime.hours)
            .minute(endTime.minutes);

        setEditFrom(finalStart.toDate());
        setEditTo(finalEnd.toDate());
        setEditNotes(data.Notes || "");
        setDecisionNote("");
        resetEditForm({
            editFrom: finalStart.toDate(),
            editTo: finalEnd.toDate(),
            editNotes: data.Notes || ""
        });

    }, [open, data]);

    const handleRegisterSubmit = async (formData) => {
        if (isSaving) return;
        setIsSaving(true);

        const userId = localStorage.getItem('UserId');
        const customerId = localStorage.getItem('customerId');
        const locationIdFromLS = localStorage.getItem('locationId');
        const newStart = moment(formData.dateFrom);
        const newEnd = moment(formData.dateTo);

        try {
            const payload = {
                userId,
                customerId,
                type: registerType,
                startDate: newStart.format('YYYY-MM-DD'),
                endDate: newEnd.format('YYYY-MM-DD'),
                startTime: newStart.utc().format('HH:mm:ss'),
                endTime: newEnd.utc().format('HH:mm:ss'),
                notes: formData.note || null,
                status: registerType === 'sickness' ? 'approved' : 'pending',
                actionBy: communicationUserId,
            };

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/userUnavailabilityRoute/unavailabilities`,
                payload,
                { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
            );

            if (response.status === 201 || response.status === 200) {
                clearEmployeeAvailabilityCache();
                // ── Close UI immediately ──
                toast.success(
                    registerType === 'sickness'
                        ? t('sickLeaveSubmitted')
                        : t('vacationRequestSubmitted'),
                    { position: 'top-right', autoClose: 2000 }
                );
                reset();
                setRegisterType('vacation');
                onClose();
                if (onUpdated) {
                    await onUpdated();
                }

                // ── Fire and forget: notifications + emails ──
                notifyLeaveRequested({
                    unavailabilityId: response.data.UnavailabilityId,
                    employeeId: userId,
                    employeeName: localStorage.getItem("UserName") || userId,
                    requestType: registerType,
                    requestStatus: registerType === "sickness" ? "Approved" : "Pending",
                    startDate: moment(formData.dateFrom).local().format("DD-MM-YYYY"),
                    endDate: moment(formData.dateTo).local().format("DD-MM-YYYY"),
                    startTime: moment(formData.dateFrom).format("HH:mm"),
                    endTime: moment(formData.dateTo).format("HH:mm"),
                    employeeNote: formData.note || "",
                    totalWorkingDays: newEnd.diff(newStart, "days") + 1,
                    customerId,
                    t,
                }).catch(err => console.error("Leave request notification error (non-blocking):", err));
            }
        } catch (error) {
            console.error('Error submitting unavailability:', error);
            toast.error(t('unavailabilitySubmitFailed'), {
                position: 'top-right',
                autoClose: 3000,
            });
        } finally {
            setIsSaving(false);
        }
    };

    const handleDelete = async () => {
        try {
            await axios.delete(
                `${process.env.REACT_APP_API_URL}/userUnavailabilityRoute/deleteUnavailability/${data.UnavailabilityId}`,
                { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
            );
            clearEmployeeAvailabilityCache();

            // remove deleted record from state
            setExistingUnavailabilities(prev =>
                prev.filter(item => item.UnavailabilityId !== data.UnavailabilityId)
            );

            toast.success(t('unavailabilityDeleted'), { position: 'top-right', autoClose: 2000 });

            setShowDeleteModal(false);
            onDeleted();

            if (onUpdated) {
                await onUpdated();
            }

            onClose();

        } catch (error) {
            console.error('Error deleting unavailability:', error);
            toast.error(t('unavailabilityDeleteFailed'), { position: 'top-right', autoClose: 3000 });
        }
    };

    const handleLeaveTypeChange = (type, setTypeFunction, options = {}) => {
        setTypeFunction(type);

        // REGISTER MODE
        if (options.setValue) {
            options.setValue(options.fromField, null);
            options.setValue(options.toField, null);
            options.clearErrors?.([options.fromField, options.toField]);
        }

        // EDIT MODE
        if (options.resetEdit) {
            resetEditForm({
                editFrom: null,
                editTo: null,
                editNotes: ""
            });
        }
    };

    const handleUpdate = async (formData) => {
        setIsSaving(true);

        try {
            const userId = data.UserId;
            const customerId = localStorage.getItem("customerId");

            const newStart = moment(formData.editFrom);
            const newEnd = moment(formData.editTo);

            const shouldCreateNew =
                isEmployeeView &&
                data.Status?.toLowerCase() !== "pending";

            const payload = {
                type: editLeaveType,
                notes: editNotes || null,
                startDate: newStart.format("YYYY-MM-DD"),
                endDate: newEnd.format("YYYY-MM-DD"),
                startTime: newStart.utc().format("HH:mm:ss"),
                endTime: newEnd.utc().format("HH:mm:ss"),
                employeeName: data.userName || '',
                adminName: localStorage.getItem('UserName') || communicationUserId,
                status: editLeaveType === 'sickness' ? 'approved' : data.Status?.toLowerCase(),
            };

            if (shouldCreateNew) {
                // Employee editing approved/rejected → create new record + notify
                const res = await axios.post(
                    `${process.env.REACT_APP_API_URL}/userUnavailabilityRoute/unavailabilities`,
                    {
                        ...payload,
                        userId,
                        customerId,
                        status: editLeaveType === "sickness" ? "approved" : "pending",
                        requestGroupId: data.RequestGroupId
                    },
                    { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
                );

                if (res && (res.status === 200 || res.status === 201)) {
                    notifyLeaveRequested({
                        unavailabilityId: res.data.UnavailabilityId,
                        employeeId: userId,
                        employeeName: data.userName || "",
                        requestType: editLeaveType,
                        requestStatus: payload.status,
                        startDate: payload.startDate,
                        endDate: payload.endDate,
                        startTime: payload.startTime,
                        endTime: payload.endTime,
                        employeeNote: payload.notes || "",
                        totalWorkingDays: newEnd.diff(newStart, "days") + 1,
                        isResubmission: true,
                        customerId,
                        t,
                    }).catch(err => console.error("Leave resubmission notification error (non-blocking):", err));
                }
            } else {
                // Employee editing pending OR admin editing → update only, no notifications
                await axios.patch(
                    `${process.env.REACT_APP_API_URL}/userUnavailabilityRoute/updateUnavailability/${data.UnavailabilityId}`,
                    {
                        ...payload,
                        actionBy: communicationUserId,
                        isTypeChange: editLeaveType !== data.Type?.toLowerCase()
                    },
                    { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
                );
            }

            toast.success(t("leaveUpdatedSuccessfully"), {
                position: "top-right",
                autoClose: 2000
            });

            if (onUpdated) await onUpdated();

            setIsEditMode(false);
            onClose();

        } catch (error) {
            console.error("Update error:", error);
            toast.error(t("unavailabilityUpdateFailed"), {
                position: "top-right",
                autoClose: 3000
            });
        } finally {
            setIsSaving(false);
        }
    };

    const handleDecisionClick = async (newStatus) => {
        if (!data?.UnavailabilityId) return;

        await onDecision(
            data.UnavailabilityId,
            newStatus,
            decisionNote
        );

        onClose();
    };

    const checkReassignmentConflict = async (emp, taskIds = selectedTaskIds) => {
        const selectedTasks = taskIds
            .map(i => affectedTasks[i])
            .filter(task => task?.Date && task?.StartTime && task?.EndTime);

        if (!selectedTasks.length) return { issues: [] };

        const dates = selectedTasks.map(t => moment(t.Date));
        const minDate = moment.min(dates);
        const maxDate = moment.max(dates);

        const inFormSlots = selectedTasks.map(task => ({
            id: task.OrderDetailId,
            employeeId: emp.UserId,
            start: moment(`${task.Date} ${task.StartTime}`, 'YYYY-MM-DD HH:mm').toDate(),
            end: moment(`${task.Date} ${task.EndTime}`, 'YYYY-MM-DD HH:mm').toDate(),
            label: task.TaskName,
            clientName: task.ClientName,
            dayKey: moment(task.Date).format("dddd").toLowerCase(),
            date: task.Date,
        }));

        const occurrenceDates = selectedTasks.map(task => moment(task.Date));

        const firstTask = selectedTasks[0];
        const startTimeOfDay = moment.utc(`${firstTask.Date}T${firstTask.StartTime}`).local();
        const endTimeOfDay = moment.utc(`${firstTask.Date}T${firstTask.EndTime}`).local();

        const issues = [];

        // ── Leave check ──
        const leaveResult = await checkEmployeeAvailability({
            employeeId: emp.UserId,
            conflictMap,
            startDate: minDate,
            endDate: maxDate,
            occurrenceDates,
            timeWindow: { startTimeOfDay, endTimeOfDay },
            inFormSlots: [],
            customerId: localStorage.getItem('customerId'),
            excludeOrderDetailId: null,
            skipBackendFetch: true,
        });

        if (leaveResult?.type === "leave") {
            issues.push({
                type: "leave",
                employeeId: emp.UserId,
                employeeName: emp.Name,
                leaveType: leaveResult.leaveType,
                leaveStatus: leaveResult.leaveStatus,
            });
        }

        const taskConflictResult = await checkEmployeeAvailability({
            employeeId: emp.UserId,
            conflictMap: {},
            startDate: minDate,
            endDate: maxDate,
            occurrenceDates,
            timeWindow: { startTimeOfDay, endTimeOfDay },
            inFormSlots,
            customerId: localStorage.getItem('customerId'),
            excludeOrderDetailId: null,
        });

        if (taskConflictResult?.type === "taskConflict") {
            issues.push({
                type: "taskConflict",
                employeeId: emp.UserId,
                employeeName: emp.Name,
                conflictTaskName: taskConflictResult.conflictTaskName,
                conflictClientName: taskConflictResult.conflictClientName,
                conflictStart: taskConflictResult.conflictStart,
                conflictEnd: taskConflictResult.conflictEnd,
            });
        }

        const hasPastDateTask = selectedTasks.some((task) =>
            moment(task.Date).isBefore(moment(), "day")
        );

        if (hasPastDateTask) {
            issues.push({
                type: "pastDateAssign",
                employeeId: emp.UserId,
                employeeName: emp.Name,
                fromEmployee: data?.userName,
                toEmployee: emp.Name,
            });
        }

        return { issues };
    };

    const StaticBackdropModal = ({ show, handleClose, handleDelete }) => (
        <Modal show={show} onHide={handleClose} backdrop="static">
            <Modal.Header>
                <Modal.Title>{t('confirmation')}</Modal.Title>
                <FalconCloseButton onClick={handleClose} />
            </Modal.Header>
            <Modal.Body>{t('confirmDeleteUnavailability')}</Modal.Body>
            <Modal.Footer>
                <Button variant="falcon-default" onClick={handleClose}>
                    {t('cancel')}
                </Button>
                <Button variant="primary" onClick={handleDelete}>
                    {t('delete')}
                </Button>
            </Modal.Footer>
        </Modal>
    );

    const noteValue = watch('note') || '';
    const watchedDateFrom = watch('dateFrom');
    const watchedDateTo = watch('dateTo');
    const isFormReady = !!watchedDateFrom && !!watchedDateTo;

    return (
        <>
            <Offcanvas
                show={open}
                onHide={onClose}
                placement="end"
                backdrop={true}
                scroll={true}
            >
                <div className="d-flex flex-column h-100 bg-white">
                    {loading ? (
                        <div className="text-center my-5">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">{t('loading')}</span>
                            </div>
                        </div>
                    ) : isRegisterMode ? (
                        <>
                            {/* Header */}
                            <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
                                <h4 className="mb-0">{t('registerUnavailability')}</h4>
                                <Button
                                    variant="link"
                                    className="p-0 border-0 shadow-none text-secondary flex-shrink-0 fs-7"
                                    onClick={onClose}
                                >
                                    <FontAwesomeIcon icon={faTimes} />
                                </Button>
                            </div>

                            {/* Scrollable Content */}
                            <div className="p-3 overflow-auto flex-grow-1 bg-200 scrollbar">

                                {/* Type of Time Off */}
                                <div className="bg-white border rounded-3 p-3 mb-3">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <h3 className="fw-medium font-size-15 mb-0">
                                            <FontAwesomeIcon icon={faUserPlus} className="text-primary font-size-13 me-2" />
                                            {t('typeOfTimeOff')}
                                        </h3>
                                        <div className="toggle-group d-inline-flex border-0 rounded-3">
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    handleLeaveTypeChange('sickness', setRegisterType, {
                                                        setValue,
                                                        clearErrors,
                                                        fromField: 'dateFrom',
                                                        toField: 'dateTo'
                                                    })
                                                }
                                                className={` border-0 ${registerType === 'sickness' ? 'active' : ''}`}
                                            >
                                                {t('sickness')}
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() =>
                                                    handleLeaveTypeChange('vacation', setRegisterType, {
                                                        setValue,
                                                        clearErrors,
                                                        fromField: 'dateFrom',
                                                        toField: 'dateTo'
                                                    })
                                                }
                                                className={` border-0 ${registerType === 'vacation' ? 'active' : ''}`}
                                            >
                                                {t('vacation')}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Date Range */}
                                <div className="bg-white border rounded-3 p-3 mb-3">
                                    <div className="d-flex align-items-center gap-2 mb-3">
                                        <FontAwesomeIcon icon={faCalendarAlt} className="text-primary font-size-13" />
                                        <h3 className="fw-medium font-size-15 mb-0">
                                            {t('selectDateAndTime')}
                                        </h3>
                                    </div>

                                    <div className="d-flex flex-column gap-3">
                                        {/* Date From */}
                                        <div>
                                            <Form.Label className="text-muted mb-1 fw-medium font-size-13">
                                                {t('dateFrom')} <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Controller
                                                control={control}
                                                name="dateFrom"
                                                render={({ field }) => (
                                                    <DatePicker
                                                        selected={field.value}
                                                        // onChange={(date) => field.onChange(date)}
                                                        onChange={(date) => {
                                                            field.onChange(date);
                                                            trigger("dateTo");
                                                        }}
                                                        showTimeSelect
                                                        timeIntervals={5}
                                                        timeCaption={t('time')}
                                                        dateFormat="dd-MM-yyyy,  HH:mm"
                                                        timeFormat="HH:mm"
                                                        placeholderText="DD-MM-YYYY, HH:MM"
                                                        popperPlacement="bottom-start"
                                                        popperContainer={({ children }) => ReactDOM.createPortal(children, document.body)}
                                                        popperProps={{ strategy: "fixed" }}
                                                        customInput={
                                                            <div className={`d-flex align-items-center border rounded-2 px-3 py-2 gap-2 ${errors.dateFrom ? 'border-danger' : ''}`}>
                                                                <span className={`flex-grow-1 font-size-12 ${field.value ? 'text-dark' : 'text-muted opacity-50'}`}>
                                                                    {field.value
                                                                        ? new Date(field.value).toLocaleString('en-GB', {
                                                                            day: '2-digit',
                                                                            month: '2-digit',
                                                                            year: 'numeric',
                                                                            hour: '2-digit',
                                                                            minute: '2-digit',
                                                                            hour12: false
                                                                        }).replace(/\//g, '-')
                                                                        : 'DD-MM-YYYY, HH:MM'}
                                                                </span>
                                                            </div>
                                                        }
                                                        // minDate={registerType === 'vacation' ? today : undefined}
                                                        minDate={undefined}
                                                        maxDate={registerType === 'sickness' ? today : undefined}
                                                    />
                                                )}
                                            />
                                            {errors.dateFrom && (
                                                <div className="text-danger d-block font-size-11 mt-1">
                                                    {errors.dateFrom.message}
                                                </div>
                                            )}
                                        </div>

                                        {/* Date To */}
                                        <div>
                                            <Form.Label className="text-muted mb-1 fw-medium font-size-13">
                                                {t('dateTo')} <span className="text-danger">*</span>
                                            </Form.Label>
                                            <Controller
                                                control={control}
                                                name="dateTo"
                                                render={({ field }) => (
                                                    <DatePicker
                                                        selected={field.value}
                                                        // onChange={(date) => field.onChange(date)}
                                                        onChange={(date) => {
                                                            if (date) {
                                                                const prev = field.value;
                                                                const isNewDate = !prev ||
                                                                    date.getDate() !== prev.getDate() ||
                                                                    date.getMonth() !== prev.getMonth() ||
                                                                    date.getFullYear() !== prev.getFullYear();

                                                                if (isNewDate) {
                                                                    date.setHours(23, 55, 0, 0);
                                                                }
                                                            }
                                                            field.onChange(date);
                                                        }}
                                                        showTimeSelect
                                                        timeIntervals={5}
                                                        timeCaption={t('time')}
                                                        dateFormat="dd-MM-yyyy, HH:mm"
                                                        timeFormat="HH:mm"
                                                        placeholderText="DD-MM-YYYY, HH:MM"
                                                        popperPlacement="bottom-start"
                                                        popperContainer={({ children }) => ReactDOM.createPortal(children, document.body)}
                                                        popperProps={{ strategy: "fixed" }}
                                                        customInput={
                                                            <div className={`d-flex align-items-center border rounded-2 px-3 py-2 gap-2 ${errors.dateTo ? 'border-danger' : ''}`}>
                                                                <span className={`flex-grow-1 font-size-12 ${field.value ? 'text-dark' : 'text-muted opacity-50'}`}>
                                                                    {field.value
                                                                        ? new Date(field.value).toLocaleString('en-GB', {
                                                                            day: '2-digit',
                                                                            month: '2-digit',
                                                                            year: 'numeric',
                                                                            hour: '2-digit',
                                                                            minute: '2-digit',
                                                                            hour12: false
                                                                        }).replace(/\//g, '-')
                                                                        : 'DD-MM-YYYY, HH:MM'}
                                                                </span>
                                                            </div>
                                                        }
                                                        minDate={dateFromValue || undefined}
                                                    />
                                                )}
                                            />
                                            {errors.dateTo && (
                                                <div className="text-danger d-block font-size-11 mt-1">
                                                    {errors.dateTo.message}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Sickness message */}
                                    {isRegisterSick && (
                                        <p className="text-muted font-size-11 mb-0 mt-3 opacity-50">
                                            {t('pastDatesAllowedSickness')}
                                        </p>
                                    )}
                                </div>

                                {/* Notes */}
                                <div className="bg-white border rounded-3 p-3 mb-3">
                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                        <div className="d-flex align-items-center gap-2">
                                            <FontAwesomeIcon icon={faFileAlt} className="text-primary font-size-13" />
                                            <h3 className="fw-medium font-size-15 mb-0">{t('notes')}</h3>
                                        </div>
                                    </div>
                                    <Controller
                                        control={control}
                                        name="note"
                                        render={({ field }) => (
                                            <Form.Control
                                                {...field}
                                                as="textarea"
                                                rows={3}
                                                placeholder={t('addANote')}
                                                className="font-size-13 bg-white"
                                                style={{ resize: 'vertical' }}
                                                onInput={(e) => {
                                                    e.target.style.height = 'auto';
                                                    e.target.style.height = e.target.scrollHeight + 'px';
                                                }}
                                            />
                                        )}
                                    />
                                </div>
                            </div>

                            {/* Footer */}
                            <div className="p-3 border-top bg-white">
                                <div className="d-flex gap-1 align-items-start mb-3">
                                    <FontAwesomeIcon icon={faInfoCircle} className="text-primary mt-1 flex-shrink-0 font-size-12" />
                                    {isRegisterSick ? (
                                        <p className="font-size-11 text-muted mb-0 lh-sm">
                                            {t('sicknessAutoApprovedPrefix')}{' '}
                                            <span className="text-success fw-medium">{t('autoApproved')}</span>{' '}
                                            {t('sicknessAutoApprovedSuffix')}
                                        </p>
                                    ) : (
                                        <p className="font-size-11 text-muted mb-0">
                                            {t('vacationPendingPrefix')}{' '}
                                        </p>
                                    )}
                                </div>
                                <div className="d-flex gap-2">
                                    <Button
                                        variant="link"
                                        className="w-50 text-secondary text-decoration-none fw-normal font-size-13 border border-secondary rounded-3"
                                        onClick={onClose}
                                        size="sm"
                                        disabled={isSaving}
                                    >
                                        {t('cancel')}
                                    </Button>
                                    <Button
                                        variant="primary"
                                        className="w-50 fw-semibold rounded-3"
                                        onClick={handleSubmit(handleRegisterSubmit)}
                                        size="sm"
                                        disabled={!isFormReady || isSaving}
                                    >
                                        {isSaving
                                            ? t('saving')
                                            : isRegisterSick
                                                ? t('submit')
                                                : t('submitRequest')}
                                    </Button>
                                </div>
                            </div>
                        </>
                    ) : (
                        // ... view mode — unchanged below this point
                        <>
                            {/* Header */}
                            <div className="p-3 border-bottom">
                                <div className="d-flex justify-content-between align-items-start mb-0">
                                    <div className="d-flex align-items-center gap-3 flex-wrap">

                                        {/* Dynamic Title */}
                                        <h4 className="mb-0">
                                            {isEmployeeView
                                                ? t("leaveRequest")
                                                : normalizedType === "sickness"
                                                    ? t("sickLeave")
                                                    : t("vacationRequest")}
                                        </h4>

                                        {/* Dynamic Status Badge */}
                                        <SubtleBadge
                                            pill
                                            bg={badgeColor}
                                            className="fw-medium font-size-12"
                                        >
                                            {t(normalizedStatus)}
                                        </SubtleBadge>
                                    </div>

                                    {/* Close Button */}
                                    <Button
                                        variant="link"
                                        className="p-0 border-0 shadow-none text-secondary flex-shrink-0 ms-2 fs-7"
                                        onClick={onClose}
                                    >
                                        <FontAwesomeIcon icon={faTimes} />
                                    </Button>
                                </div>
                            </div>

                            {/* Scrollable Content */}
                            <div className="p-3 overflow-auto flex-grow-1 scrollbar">

                                {/* Employee Section */}
                                <div className="mb-3">
                                    <div className="d-flex align-items-center justify-content-between mb-1">
                                        <h3 className="fw-medium font-size-15 mb-0">
                                            {t('employee')}
                                        </h3>
                                    </div>

                                    <div className="bg-100 border rounded-3 px-3 py-2">
                                        <div className="d-flex align-items-center gap-3">

                                            {/* Initials Avatar */}
                                            <div
                                                className={`rounded-circle d-flex align-items-center justify-content-center ${data?.avatarColor} flex-shrink-0`}
                                                style={{ width: '35px', height: '35px', fontSize: '13px', fontWeight: 600 }}
                                            >
                                                {data?.userName
                                                    ?.trim()
                                                    .split(' ')
                                                    .filter(word => word.length > 0)
                                                    .map(word => word.charAt(0))
                                                    .join('')
                                                    .substring(0, 2)
                                                    .toUpperCase() || '--'}
                                            </div>

                                            {/* Name & Role */}
                                            <div className="flex-grow-1 min-width-0">
                                                <p className="mb-0 fw-medium font-size-13 text-truncate">
                                                    {data?.userName || '--'}
                                                </p>
                                                <span className="text-muted d-block fw-normal font-size-12">
                                                    <span className="text-muted d-block fw-normal font-size-12">
                                                        {data?.userRole ? t(data.userRole) : "--"}
                                                    </span>
                                                </span>
                                            </div>

                                            {/* Balance Section Commented Out */}
                                            {/*
                                                    <div className="text-end flex-shrink-0">
                                                        <span className="d-block fw-normal font-size-12 text-muted">
                                                        {t('balance')}
                                                        </span>
                                                        <span className="fw-bold d-block font-size-12 text-success mb-0">
                                                        {isSick ? t('sixDaysLeft') : t('eightDaysLeft')}
                                                        </span>
                                                    </div>
                                                    */}
                                        </div>
                                    </div>
                                </div>

                                {/* Request Details Section */}
                                <div className="mb-3">
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                        <h3 className="fw-medium font-size-15 mb-0">
                                            {t('leaveSummary')}
                                        </h3>
                                        {!isEditMode && mode !== 'readonly' && (
                                            <div className="d-flex align-items-center gap-2">
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip id="edit-tooltip">{t('edit')}</Tooltip>}
                                                >
                                                    <span className="d-inline-block">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link p-1 text-secondary shadow-none"
                                                            onClick={() => setIsEditMode(true)}
                                                            disabled={!canEmployeeEdit || disableEdit || disableSickEditForEmployeeView}
                                                        >
                                                            <i className="fas fa-pencil-alt font-size-14" />
                                                        </button>
                                                    </span>
                                                </OverlayTrigger>

                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={<Tooltip id="delete-tooltip">{t('delete')}</Tooltip>}
                                                >
                                                    <span className="d-inline-block">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link p-1 text-danger shadow-none"
                                                            onClick={() => setShowDeleteModal(true)}
                                                            disabled={!canEmployeeEdit || disableEdit || disableSickEditForEmployeeView}
                                                        >
                                                            <i className="fas fa-trash-alt font-size-14" />
                                                        </button>
                                                    </span>
                                                </OverlayTrigger>
                                            </div>
                                        )}
                                    </div>

                                    {isEditMode ? (
                                        <div className="border rounded-3 p-3 bg-white">
                                            {/* Leave Type Toggle */}
                                            <div className="mb-2">
                                                <div className="d-flex align-items-center justify-content-between">
                                                    <Form.Label className="mb-0 text-muted fw-medium font-size-13">
                                                        {t('leaveType')}
                                                    </Form.Label>
                                                    <div className="toggle-group d-inline-flex border-0 rounded">
                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                handleLeaveTypeChange('sickness', setEditLeaveType, {
                                                                    resetEdit: true
                                                                })
                                                            }

                                                            className={`border-0 ${editLeaveType === 'sickness' ? 'active' : ''}`}
                                                        >
                                                            {t('sickness')}
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() =>
                                                                handleLeaveTypeChange('vacation', setEditLeaveType, {
                                                                    resetEdit: true
                                                                })
                                                            }
                                                            className={`border-0 ${editLeaveType === 'vacation' ? 'active' : ''}`}
                                                        >
                                                            {t('vacation')}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* FROM */}
                                            <div className="mb-2">
                                                <Form.Label className="text-muted mb-1 fw-medium font-size-13">
                                                    {t('dateFrom')}
                                                </Form.Label>
                                                <Controller
                                                    control={editControl}
                                                    name="editFrom"
                                                    render={({ field }) => (
                                                        <DatePicker
                                                            selected={field.value}
                                                            onChange={(date) => {
                                                                field.onChange(date);
                                                                triggerEdit("editTo");
                                                            }}
                                                            showTimeSelect
                                                            timeIntervals={5}
                                                            timeCaption={t('time')}
                                                            dateFormat="DD-MM-YYYY, HH:mm"
                                                            timeFormat="HH:mm"
                                                            popperPlacement="bottom-start"
                                                            popperContainer={({ children }) =>
                                                                ReactDOM.createPortal(children, document.body)
                                                            }
                                                            popperProps={{ strategy: 'fixed' }}
                                                            customInput={
                                                                <div className={`d-flex align-items-center border rounded-2 px-3 py-2 gap-2 cursor-pointer ${editErrors.editFrom ? 'border-danger' : ''}`}>
                                                                    <span className={`flex-grow-1 font-size-12 ${field.value ? 'text-dark' : 'text-muted opacity-50'}`}>
                                                                        {field.value
                                                                            ? moment(field.value).format("DD-MM-YYYY, HH:mm")
                                                                            : "DD-MM-YYYY, HH:mm"}
                                                                    </span>
                                                                </div>
                                                            }
                                                        />
                                                    )}
                                                />

                                                {editErrors.editFrom && (
                                                    <div className="text-danger font-size-11 mt-1">
                                                        {editErrors.editFrom.message}
                                                    </div>
                                                )}
                                            </div>

                                            {/* TO */}
                                            <div className="mb-2">
                                                <Form.Label className="text-muted mb-1 fw-medium font-size-13">
                                                    {t('dateTo')}
                                                </Form.Label>
                                                <Controller
                                                    control={editControl}
                                                    name="editTo"
                                                    render={({ field }) => (
                                                        <DatePicker
                                                            selected={field.value}
                                                            onChange={(date) => {
                                                                if (date) {
                                                                    const prev = field.value;
                                                                    const isNewDate = !prev ||
                                                                        date.getDate() !== prev.getDate() ||
                                                                        date.getMonth() !== prev.getMonth() ||
                                                                        date.getFullYear() !== prev.getFullYear();

                                                                    if (isNewDate) {
                                                                        date.setHours(23, 55, 0, 0);
                                                                    }
                                                                }
                                                                field.onChange(date);
                                                                setEditTo(date);
                                                            }}
                                                            showTimeSelect
                                                            timeIntervals={5}
                                                            timeCaption={t('time')}
                                                            dateFormat="DD-MM-YYYY, HH:mm"
                                                            timeFormat="HH:mm"
                                                            popperPlacement="bottom-start"
                                                            popperContainer={({ children }) =>
                                                                ReactDOM.createPortal(children, document.body)
                                                            }
                                                            popperProps={{ strategy: 'fixed' }}
                                                            // minDate={editFrom || new Date()}
                                                            minDate={watchedEditFrom || undefined}
                                                            customInput={
                                                                <div className={`d-flex align-items-center border rounded-2 px-3 py-2 gap-2 cursor-pointer ${editErrors.editTo ? 'border-danger' : ''}`}>
                                                                    <span className={`flex-grow-1 font-size-12 ${field.value ? 'text-dark' : 'text-muted opacity-50'}`}>
                                                                        {field.value
                                                                            ? moment(field.value).format("DD-MM-YYYY, HH:mm")
                                                                            : "DD-MM-YYYY, HH:mm"}
                                                                    </span>
                                                                </div>
                                                            }
                                                        />
                                                    )}
                                                />

                                                {editErrors.editTo && (
                                                    <div className="text-danger font-size-11 mt-1">
                                                        {editErrors.editTo.message}
                                                    </div>
                                                )}

                                            </div>

                                            {/* Employee Note */}
                                            {isEmployeeView && isEditMode && (
                                                <div >
                                                    <Form.Label className="mb-1 text-muted fw-medium font-size-13">
                                                        {t('employeeNote')}
                                                    </Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        rows={2}
                                                        value={editNotes}
                                                        onChange={(e) => setEditNotes(e.target.value)}
                                                        className="font-size-13 bg-white"
                                                        style={{ resize: 'none' }}
                                                    />
                                                </div>
                                            )}

                                            {/* Save / Cancel */}
                                            <div className="mt-3 d-flex gap-2 justify-content-end">
                                                <Button
                                                    variant="primary"
                                                    size="sm"
                                                    className="fw-semibold px-3 rounded-3"
                                                    disabled={isSaving}
                                                    // onClick={handleUpdate}
                                                    onClick={handleEditSubmit(handleUpdate)}
                                                >
                                                    {isSaving ? t("updating") : t("update")}
                                                </Button>
                                                <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    className="fw-normal font-size-13 px-3 rounded-3"
                                                    onClick={() => setIsEditMode(false)}
                                                >
                                                    {t('cancel')}
                                                </Button>
                                            </div>
                                        </div>
                                    ) : (
                                        <>
                                            <div className="row g-3">
                                                <div className="col-6">
                                                    <p className="mb-0 text-muted fw-medium font-size-13">
                                                        {t('leaveType')}
                                                    </p>
                                                    <span className="text-muted d-flex align-items-center gap-1 mb-0 fw-normal font-size-12">
                                                        {t(data?.Type?.toLowerCase())}
                                                    </span>
                                                </div>
                                                <div className="col-6">
                                                    <p className="mb-0 text-muted fw-medium font-size-13">
                                                        {t('dateRange')}
                                                    </p>
                                                    <span className="text-muted d-flex align-items-center gap-1 mb-0 fw-normal font-size-12">
                                                        {`${moment(data?.StartDate).format("DD-MM-YYYY")} - ${moment(data?.EndDate).format("DD-MM-YYYY")}`}
                                                    </span>
                                                </div>
                                                <div className="col-6">
                                                    <p className="mb-0 text-muted fw-medium font-size-13">
                                                        {t('time')}
                                                    </p>
                                                    <span className="text-muted d-flex align-items-center gap-1 mb-0 fw-normal font-size-12">
                                                        {formatTimeRange()}
                                                    </span>
                                                    {!isSick && (() => {
                                                        if (data?.StartTime && data?.EndTime) {
                                                            const diff = moment.utc(data.EndTime).diff(moment.utc(data.StartTime), "minutes") / 60;
                                                            if (diff > 0 && diff < 8) return null; // partial leave — no hint
                                                        }
                                                        return (
                                                            <p className="mb-0 fw-normal font-size-11 mt-1">
                                                                {t('fullDayLeaveNoSpecificHours')}
                                                            </p>
                                                        );
                                                    })()}
                                                </div>
                                                <div className="col-6">
                                                    <p className="mb-0 text-muted fw-medium font-size-13">
                                                        {t('duration')}
                                                    </p>
                                                    <span className="text-muted d-flex align-items-center gap-1 mb-0 fw-normal font-size-12">
                                                        {calculateDuration()}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="mt-3">
                                                <p className="mb-1 text-muted fw-medium font-size-13">{t('employeeNote')}</p>
                                                <div className="bg-100 border-start border-3 border-success rounded-2 px-3 py-2">
                                                    <p className="text-muted d-flex align-items-center gap-1 mb-0 fw-normal font-size-12">
                                                        {editNotes ? `${editNotes}` : t("noNotesAvailable")}
                                                    </p>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                                {showTasks && (
                                    <div className="mb-3">
                                        <h3 className="fw-medium font-size-15 mb-2">{t('affectedTasks')}</h3>

                                        {tasksLoading ? (
                                            <div className="d-flex flex-column justify-content-center align-items-center py-4">
                                                <Spinner animation="border" size="sm" className="mb-2" />
                                                <div className="text-muted font-size-12 text-center">
                                                    {t('loadingAffectedTasks')}
                                                </div>
                                            </div>
                                        ) : affectedTasks.length === 0 ? (
                                            <div className="text-muted font-size-12 text-start py-2">
                                                {t('noAffectedTasks')}
                                            </div>
                                        ) : (
                                            <>
                                                {/* Select All Row */}
                                                {showTaskCheckboxes && (
                                                    <div className={`mb-2 px-1 ${selectedTaskIds.length === 0 ? 'd-none' : ''}`}>
                                                        <div className="d-flex align-items-center gap-2 mb-2">
                                                            <Form.Check
                                                                type="checkbox"
                                                                id="select-all-tasks"
                                                                checked={
                                                                    selectedTaskIds.length === affectedTasks.length &&
                                                                    affectedTasks.length > 0
                                                                }
                                                                onChange={() => {
                                                                    if (selectedTaskIds.length === affectedTasks.length) {
                                                                        setSelectedTaskIds([]);
                                                                        setActiveReassignIdx(null);
                                                                        setShouldReassignAllAffectedTasks(false);
                                                                    } else {
                                                                        setSelectedTaskIds(affectedTasks.map((_, i) => i));
                                                                        setActiveReassignIdx(0);
                                                                        setShouldReassignAllAffectedTasks(true);
                                                                    }
                                                                }}
                                                            />
                                                            <span
                                                                className="font-size-13 fw-medium text-700"
                                                                onClick={e => e.stopPropagation()}
                                                            >
                                                                {t('selectAllTasks')}
                                                            </span>
                                                        </div>
                                                        {selectedTaskIds.length > 0 && (
                                                            <span className="text-primary font-size-12 ms-1 d-block mt-n1">
                                                                {selectedTaskIds.length} / {affectedTasks.length} {t('tasksSelected')}
                                                            </span>
                                                        )}
                                                    </div>
                                                )}

                                                {/* Task Cards */}
                                                <div className="d-flex flex-column gap-2">
                                                    {(showAllTasks ? affectedTasks : affectedTasks.slice(0, 4)).map((task, idx) => {
                                                        const isSelected = selectedTaskIds.includes(idx);
                                                        const isReassignOpen = activeReassignIdx === idx;

                                                        return (
                                                            <div key={idx}>
                                                                {/* Task Card */}
                                                                <div
                                                                    className={`card shadow-none border rounded-3 mb-0 task-hover-card ${isSelected ? 'border-primary' : 'border-200'}`}
                                                                    style={{ cursor: showTaskCheckboxes ? 'pointer' : 'default' }}
                                                                    onClick={() => {
                                                                        if (!showTaskCheckboxes) return;
                                                                        const nowSelected = !isSelected;
                                                                        setSelectedTaskIds(prev =>
                                                                            prev.includes(idx)
                                                                                ? prev.filter(i => i !== idx)
                                                                                : [...prev, idx]
                                                                        );
                                                                        if (nowSelected) {
                                                                            setActiveReassignIdx(idx);
                                                                            setAssignToEmployee(null);
                                                                            setShouldReassignAllAffectedTasks(false);
                                                                        } else {
                                                                            setActiveReassignIdx(null);
                                                                        }
                                                                    }}
                                                                >
                                                                    <div className="card-body py-2 px-3 overflow-hidden">
                                                                        {/* Top row: checkbox + icon + task info + client */}
                                                                        <div className="d-flex align-items-start gap-2 w-100">
                                                                            {showTaskCheckboxes && (
                                                                                <div
                                                                                    className={`task-checkbox-wrap flex-shrink-0 mt-1 ${isSelected || selectedTaskIds.length > 0 ? 'visible' : ''}`}
                                                                                    onClick={e => e.stopPropagation()}
                                                                                >
                                                                                    <Form.Check
                                                                                        type="checkbox"
                                                                                        checked={isSelected}
                                                                                        onChange={() => {
                                                                                            const nowSelected = !isSelected;
                                                                                            setSelectedTaskIds(prev =>
                                                                                                prev.includes(idx)
                                                                                                    ? prev.filter(i => i !== idx)
                                                                                                    : [...prev, idx]
                                                                                            );
                                                                                            if (nowSelected) {
                                                                                                setActiveReassignIdx(idx);
                                                                                                setAssignToEmployee(null);
                                                                                                setShouldReassignAllAffectedTasks(false);
                                                                                            } else {
                                                                                                setActiveReassignIdx(null);
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            )}

                                                                            <div className="flex-grow-1 min-width-0 overflow-hidden">
                                                                                <OverlayTrigger
                                                                                    placement="top"
                                                                                    overlay={<Tooltip id={`task-tooltip-${idx}`}>{task.TaskName}</Tooltip>}
                                                                                >
                                                                                    <p className="mb-0 fw-semibold text-primary font-size-13 text-truncate w-100">
                                                                                        {task.TaskName}
                                                                                    </p>
                                                                                </OverlayTrigger>
                                                                                <p className="mb-0 text-600 font-size-12">
                                                                                    {`${moment(task.Date).format('DD')} ${t(`shortMonths.${moment(task.Date).format('MMMM').toLowerCase()}`)} ${moment(task.Date).format('YYYY')}`} |{' '}
                                                                                    {/* {task.StartTime} - {task.EndTime} */}
                                                                                    {formatTaskLocalTime(task.Date, task.StartTime)} - {formatTaskLocalTime(task.Date, task.EndTime)}
                                                                                </p>
                                                                            </div>
                                                                            <p className="mb-0 text-600 font-size-12 text-end flex-shrink-0">
                                                                                {task.ClientName}
                                                                            </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                {affectedTasks.length > 4 && (
                                                    <div className="d-flex justify-content-center mt-2">
                                                        <button
                                                            type="button"
                                                            className="btn p-0 font-size-12 text-primary shadow-none d-flex align-items-center gap-1"
                                                            onClick={() => setShowAllTasks(prev => !prev)}
                                                        >
                                                            <FontAwesomeIcon icon={showAllTasks ? faChevronUp : faChevronDown} className="font-size-11" />
                                                            {showAllTasks ? t('viewLess') : `${t('viewAll')}`}
                                                        </button>
                                                    </div>
                                                )}

                                                {/* Reassign Tasks — appears at bottom after all task cards */}
                                                {selectedTaskIds.length > 0 && (
                                                    <div className="mt-3 p-3 bg-100 border border-200 rounded-3">
                                                        <h3 className="fw-medium font-size-14 mb-2 text-700">
                                                            {t('reassignTasks')}
                                                        </h3>

                                                        <Form.Group className="mb-2">
                                                            <Form.Label className="font-size-12 text-600 fw-medium mb-1">
                                                                {t('assignTo')}
                                                            </Form.Label>
                                                            <Select
                                                                placeholder={t('selectEmployee')}
                                                                isLoading={employeesLoading}
                                                                isClearable
                                                                options={recommendedEmployeeGroups[activeReassignIdx]?.recommended?.length > 0 ? [
                                                                    {
                                                                        label: t('recommendedEmployees'),
                                                                        options: recommendedEmployeeGroups[activeReassignIdx].recommended.map(emp => ({
                                                                            value: emp.UserId,
                                                                            label: emp.Name
                                                                        }))
                                                                    },
                                                                    {
                                                                        label: t('allEmployees'),
                                                                        options: recommendedEmployeeGroups[activeReassignIdx].others.map(emp => ({
                                                                            value: emp.UserId,
                                                                            label: emp.Name
                                                                        }))
                                                                    },
                                                                ] : sortEmployeesAscending(getFilteredEmployees()).map(emp => ({
                                                                    value: emp.UserId,
                                                                    label: emp.Name
                                                                }))}
                                                                value={
                                                                    assignToEmployee
                                                                        ? { value: assignToEmployee.UserId, label: assignToEmployee.Name }
                                                                        : null
                                                                }
                                                                onChange={async (selected) => {
                                                                    const emp = employees.find(e => e.UserId === selected?.value) || null;

                                                                    if (!emp) {
                                                                        setAssignToEmployee(null);
                                                                        return;
                                                                    }

                                                                    try {
                                                                        const { issues } = await checkReassignmentConflict(emp);

                                                                        if (issues.length >= 1) {
                                                                            setPendingAssignEmployee(emp);
                                                                            setPendingCombinedIssues(issues);
                                                                            setShowCombinedIssuesModal(true);
                                                                            return;
                                                                        }

                                                                        setAssignToEmployee(emp);
                                                                    } catch (err) {
                                                                        console.error('Error checking reassignment conflicts:', err);
                                                                        setAssignToEmployee(emp);
                                                                    }
                                                                }}
                                                                className="custom-select-container custom-select-sm"
                                                                classNamePrefix="custom-select"
                                                            />
                                                        </Form.Group>

                                                        {assignToEmployee && (
                                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    id="apply-to-all"
                                                                    checked={shouldReassignAllAffectedTasks}
                                                                    onChange={e => {
                                                                        setShouldReassignAllAffectedTasks(e.target.checked);
                                                                        if (e.target.checked) {
                                                                            setPreApplySelection(selectedTaskIds);
                                                                            setSelectedTaskIds(affectedTasks.map((_, i) => i));
                                                                        } else {
                                                                            setSelectedTaskIds(preApplySelection);
                                                                        }
                                                                    }}
                                                                />
                                                                <span
                                                                    className="font-size-13 text-700"
                                                                    onClick={e => e.stopPropagation()}
                                                                >
                                                                    {t('applyToAllAffectedTasks')}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                )}

                                {historyRecords.length > 0 && (
                                    <div className="mb-3">
                                        <h3 className="fw-medium font-size-15">{t('history')}</h3>

                                        {historyLoading ? (
                                            <Spinner animation="border" role="status">
                                                <span className="visually-hidden">{t("loading")}</span>
                                            </Spinner>
                                        ) : (
                                            <>
                                                {(showAllHistory ? historyRecords : historyRecords.slice(0, 3)).map((item, index) => {
                                                    const isApprovedAction = item.ActionType === "APPROVED";
                                                    const isRejectedAction = item.ActionType === "REJECTED";
                                                    const isSickMarked = item.ActionType === "SICK_MARKED";
                                                    const isReassigned = item.ActionType === "REASSIGNED";
                                                    const isEdited = item.ActionType === "EDITED";
                                                    const isMarkedAvailable = item.ActionType === "MARKED_AVAILABLE";

                                                    return (
                                                        <div key={item.UnavailabilityHistoryId} className="d-flex gap-2 mb-3">
                                                            <div className="d-flex flex-column align-items-center">
                                                                <FontAwesomeIcon
                                                                    icon={faCircle}
                                                                    className={
                                                                        isApprovedAction ? "text-success mt-1"
                                                                            : isRejectedAction ? "text-danger mt-1"
                                                                                : isSickMarked ? "text-warning mt-1"
                                                                                    : isReassigned ? "text-info mt-1"
                                                                                        : isEdited ? "text-secondary mt-1"
                                                                                            : "text-primary mt-1"
                                                                    }
                                                                    style={{ fontSize: "10px" }}
                                                                />
                                                                {index !== (showAllHistory ? historyRecords : historyRecords.slice(0, 3)).length - 1 && (
                                                                    <div
                                                                        style={{
                                                                            width: "1px",
                                                                            flex: 1,
                                                                            marginTop: "4px",
                                                                            backgroundColor: "#dee2e6"
                                                                        }}
                                                                    />
                                                                )}
                                                            </div>

                                                            <div className="flex-grow-1">
                                                                <p className="mb-0 fw-semibold font-size-13">
                                                                    {isSickMarked
                                                                        ? `${t('sickLeaveMarkedBy')} ${item.ActionByName}`
                                                                        : isReassigned
                                                                            ? `${t('taskReassignedBy')} ${item.ActionByName}`
                                                                            : isMarkedAvailable
                                                                                ? t('employeeMarkedAvailable')
                                                                                : item.ActionType === 'EDITED'
                                                                                    ? `${t('leaveEditedBy')} ${item.ActionByName}`
                                                                                    : `${t(item.ActionType?.toLowerCase())} ${t('by')} ${item.ActionByName}`
                                                                    }
                                                                </p>

                                                                <span className="text-muted fw-normal d-block font-size-12">
                                                                    {item.ActionOn
                                                                        ? moment(item.ActionOn).local().format("DD-MM-YYYY, HH:mm")
                                                                        : "--"}
                                                                </span>

                                                                {isEdited && (item.OldStartDate || item.NewStartDate) && (
                                                                    <div className="bg-100 border-start border-3 border-secondary rounded-2 px-3 py-2 mt-2">
                                                                        <p className="mb-1 fw-medium font-size-12 text-dark">
                                                                            {`${t('leaveChangedFrom')} ${moment.utc(item.OldStartDate).format("DD")} ${t(`shortMonths.${moment.utc(item.OldStartDate).format("MMMM").toLowerCase()}`)} ${moment.utc(item.OldStartDate).format("YYYY")}${item.OldStartTime ? `, ${moment.utc(item.OldStartTime).format("HH:mm")}` : ""} → ${moment.utc(item.OldEndDate).format("DD")} ${t(`shortMonths.${moment.utc(item.OldEndDate).format("MMMM").toLowerCase()}`)} ${moment.utc(item.OldEndDate).format("YYYY")}${item.OldEndTime ? `, ${moment.utc(item.OldEndTime).format("HH:mm")}` : ""}`}
                                                                        </p>
                                                                        <p className="mb-0 fw-medium font-size-12 text-dark">
                                                                            {`${t('to')} ${moment.utc(item.NewStartDate).format("DD")} ${t(`shortMonths.${moment.utc(item.NewStartDate).format("MMMM").toLowerCase()}`)} ${moment.utc(item.NewStartDate).format("YYYY")}${item.NewStartTime ? `, ${moment.utc(item.NewStartTime).format("HH:mm")}` : ""} → ${moment.utc(item.NewEndDate).format("DD")} ${t(`shortMonths.${moment.utc(item.NewEndDate).format("MMMM").toLowerCase()}`)} ${moment.utc(item.NewEndDate).format("YYYY")}${item.NewEndTime ? `, ${moment.utc(item.NewEndTime).format("HH:mm")}` : ""}`}
                                                                        </p>
                                                                    </div>
                                                                )}
                                                                {isMarkedAvailable && (
                                                                    <div className="bg-100 border-start border-3 border-primary rounded-2 px-3 py-2 mt-2">
                                                                        <p className="mb-0 fw-medium font-size-12 text-dark">
                                                                            {t('markedAvailableComment', {
                                                                                adminName: item.ActionByName,
                                                                                employeeName: item.EmployeeName || data?.userName,
                                                                                fromDate: `${moment.utc(item.OldStartDate).format('DD')} ${t(`shortMonths.${moment.utc(item.OldStartDate).format('MMMM').toLowerCase()}`)} ${moment.utc(item.OldStartDate).format('YYYY')}`,
                                                                                toDate: `${moment.utc(item.NewEndDate).format('DD')} ${t(`shortMonths.${moment.utc(item.NewEndDate).format('MMMM').toLowerCase()}`)} ${moment.utc(item.NewEndDate).format('YYYY')}`
                                                                            })}
                                                                        </p>
                                                                    </div>
                                                                )}

                                                                {item.Comment && !isMarkedAvailable && (
                                                                    <div
                                                                        className={`bg-100 border-start border-3 rounded-2 px-3 py-2 mt-2 ${isApprovedAction
                                                                            ? "border-success"
                                                                            : isRejectedAction
                                                                                ? "border-danger"
                                                                                : isReassigned
                                                                                    ? "border-info"
                                                                                    : "border-primary"
                                                                            }`}
                                                                    >
                                                                        <p className="mb-0 fw-medium font-size-12 text-dark">
                                                                            {isReassigned && item.Comment
                                                                                ? item.Comment
                                                                                    .replace('Task', t('task'))
                                                                                    .replace('reassigned from', t('reassignedFrom'))
                                                                                    .replace(' to ', ` ${t('to')} `)
                                                                                : item.Comment}
                                                                        </p>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}

                                                {historyRecords.length > 3 && (
                                                    <div className="d-flex justify-content-center mt-2">
                                                        <button
                                                            type="button"
                                                            className="btn p-0 font-size-12 text-primary shadow-none d-flex align-items-center gap-1"
                                                            onClick={() => setShowAllHistory(prev => !prev)}
                                                        >
                                                            <FontAwesomeIcon icon={showAllHistory ? faChevronUp : faChevronDown} className="font-size-11" />
                                                            {showAllHistory ? t('viewLess') : t('viewAll')}
                                                        </button>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                )}
                                {/* {!isEmployeeView && !isEditMode && !isSick && mode !== "readonly" && data?.Status === "pending" && ( */}

                                {!isEmployeeView && !isEditMode && !isSick && mode !== 'readonly' && showAdminNotes && !isCalendarMode && (
                                    <div>
                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                            <h3 className="mb-0 fw-medium font-size-15">
                                                {t("notes")}
                                            </h3>
                                        </div>

                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            placeholder={t("addCommentForRecord")}
                                            value={decisionNote}
                                            onChange={(e) => setDecisionNote(e.target.value)}
                                            className="bg-white font-size-13"
                                        />
                                    </div>
                                )}

                            </div>

                            {/* Footer */}
                            {!isEmployeeView && mode !== 'readonly' && (!isCalendarMode || isApproved) && (
                                <div className="p-3 border-top bg-white">
                                    {isSick && !isApproved ? (
                                        <div className="d-flex flex-column gap-2">
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                className="d-flex align-items-center justify-content-center gap-2 w-100 fw-semibold rounded-3"
                                                disabled
                                            >
                                                <span>{t('replaceWithAnotherEmployee')}</span>
                                            </Button>
                                            <Button
                                                variant="link"
                                                size="sm"
                                                className="text-secondary fw-normal font-size-13 text-decoration-none w-100 d-flex align-items-center border-sm justify-content-center"
                                                disabled
                                            >
                                                {t('viewAvailabilitySuggestions')}
                                            </Button>
                                        </div>
                                    ) : isApproved ? (
                                        <div className="d-flex flex-column gap-2">
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                className="d-flex align-items-center justify-content-center gap-2 w-100 fw-semibold rounded-3"
                                                disabled={!assignToEmployee || selectedTaskIds.length === 0 || isSaving}
                                                onClick={async () => {
                                                    setIsSaving(true);
                                                    try {
                                                        const tasksToAssign = shouldReassignAllAffectedTasks
                                                            ? affectedTasks
                                                            : selectedTaskIds.map(i => affectedTasks[i]);

                                                        await Promise.all(
                                                            tasksToAssign.map(task =>
                                                                axios.patch(
                                                                    `${process.env.REACT_APP_API_URL}/orderRoute/updateOrderDetail`,
                                                                    {
                                                                        orderDetailId: task.OrderDetailId,
                                                                        updates: { CleanerId: assignToEmployee.UserId },
                                                                        performedBy: localStorage.getItem("UserId"),
                                                                    },
                                                                    { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
                                                                )
                                                            )
                                                        );
                                                        clearEmployeeAvailabilityCache();

                                                        try {
                                                            await Promise.all(
                                                                tasksToAssign.map(task =>
                                                                    axios.post(
                                                                        `${process.env.REACT_APP_API_URL}/userUnavailabilityHistoryRoute/createHistory`,
                                                                        {
                                                                            requestGroupId: data.RequestGroupId,
                                                                            unavailabilityId: data.UnavailabilityId,
                                                                            userId: data.UserId,
                                                                            customerId: data.CustomerId,
                                                                            actionType: 'REASSIGNED',
                                                                            actionBy: communicationUserId,
                                                                            comment: `Task "${task.TaskName}" reassigned from ${data.userName} to ${assignToEmployee.Name}`
                                                                        },
                                                                        { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
                                                                    )
                                                                )
                                                            );
                                                        } catch (historyErr) {
                                                            console.error('Failed to save reassignment history:', historyErr);
                                                        }

                                                        try {
                                                            if (assignToEmployee?.Emailaddress) {
                                                                await axios.post(
                                                                    `${process.env.REACT_APP_API_URL}/emailRoute/sendTaskReassignmentEmail`,
                                                                    {
                                                                        to: assignToEmployee.Emailaddress,
                                                                        cleanerName: assignToEmployee.Name,
                                                                        culture: localStorage.getItem('culture') || 'nl',
                                                                        userId: localStorage.getItem('UserId'),
                                                                        organizationName: localStorage.getItem('OrganizationName') || '',
                                                                        customerId: data.CustomerId,
                                                                        tasks: tasksToAssign.map(t => ({
                                                                            taskName: t.TaskName,
                                                                            clientName: t.ClientName,
                                                                            date: t.Date,
                                                                            startTime: t.StartTime,
                                                                            endTime: t.EndTime,
                                                                            frequency: t.Frequency || ""
                                                                        }))
                                                                    },
                                                                    { headers: { Authorization: process.env.REACT_APP_BasicAuthSecret } }
                                                                );
                                                            }
                                                        } catch (emailErr) {
                                                            // Email failure must NOT block reassignment success
                                                            console.error('Failed to send reassignment email:', emailErr);
                                                        }
                                                        setSelectedTaskIds([]);
                                                        setAssignToEmployee(null);
                                                        setShouldReassignAllAffectedTasks(false);
                                                        setActiveReassignIdx(null);
                                                        if (onUpdated) await onUpdated();
                                                        await fetchAffectedTasks();
                                                        await fetchHistory();
                                                        toast.success(t('tasksAssignedSuccessfully'), { position: 'top-right', autoClose: 2000 });
                                                    } catch (err) {
                                                        console.error('Assign tasks error:', err);
                                                        toast.error(t('tasksAssignFailed'), { position: 'top-right', autoClose: 3000 });
                                                    } finally {
                                                        setIsSaving(false);
                                                    }
                                                }}
                                            >
                                                {/* <span>{t('assignTasks')}</span> */}
                                                {isSaving
                                                    ? <><Spinner animation="border" size="sm" className="me-1" />{t('assigning')}</>
                                                    : <span>{t('assignTasks')}</span>
                                                }
                                            </Button>

                                            <Button
                                                variant="link"
                                                size="sm"
                                                className="text-secondary fw-normal font-size-13 text-decoration-none w-100 d-flex align-items-center justify-content-center"
                                                disabled
                                            >
                                                {t('viewAvailabilitySuggestions')}
                                            </Button>
                                        </div>
                                    ) : showDecisionButtons && (
                                        <div>
                                            <div className="d-flex">
                                                <Button
                                                    variant="danger"
                                                    size="sm"
                                                    className="d-flex align-items-center justify-content-center gap-2 w-50 fw-semibold rounded-3 me-2"
                                                    disabled={decisionLoading !== null || status === "rejected"}
                                                    onClick={() => handleDecisionClick("rejected")}
                                                >
                                                    {decisionLoading === "rejected"
                                                        ? t("rejecting")
                                                        : t("reject")}
                                                </Button>
                                                <Button
                                                    variant="success"
                                                    size="sm"
                                                    className="d-flex align-items-center justify-content-center gap-2 w-50 fw-semibold rounded-3"
                                                    disabled={decisionLoading !== null}
                                                    onClick={() => handleDecisionClick("approved")}
                                                >
                                                    {decisionLoading === "approved"
                                                        ? t("approving")
                                                        : t("approve")}
                                                </Button>
                                            </div>
                                            <div className="d-flex gap-2 align-items-start pt-2">
                                                <FontAwesomeIcon icon={faInfoCircle} className="text-500 mt-1 flex-shrink-0 fs-11" />
                                                <p className="fs-11 text-500 mb-0 lh-sm">
                                                    {t('approveVacationWarning')}
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                        </>
                    )}
                </div>
            </Offcanvas>
            <StaticBackdropModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleDelete={handleDelete}
            />
            <SchedulingIssuesModal
                show={showCombinedIssuesModal}
                issues={pendingCombinedIssues || []}
                t={t}
                onCancel={() => {
                    setShowCombinedIssuesModal(false);
                    setPendingCombinedIssues(null);
                    setPendingAssignEmployee(null);
                    setAssignToEmployee(null);
                }}
                onConfirm={() => {
                    setShowCombinedIssuesModal(false);
                    setPendingCombinedIssues(null);
                    setAssignToEmployee(pendingAssignEmployee);
                    setPendingAssignEmployee(null);
                }}
            />
        </>
    );
};

export default UnavailabilitySidepanel;